import React from "react";
import { Box, Typography, useTheme, alpha } from "@mui/material";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

const EditorialBanner: React.FC = () => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        padding: "12px 16px",
        borderRadius: "10px",
        backgroundColor: alpha(theme.palette.info.main, 0.12),
        border: `1px solid ${alpha(theme.palette.info.main, 0.4)}`,
      }}
    >
      <Box sx={{ display: "flex", color: theme.palette.info.main, mt: "2px" }}>
        <Info size={18} />
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            color: theme.palette.text.primary,
            lineHeight: 1.4,
          }}
        >
          {t("editorial.banner.title")}
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            color: theme.palette.text.primary,
            mt: 0.5,
            lineHeight: 1.5,
          }}
        >
          {t("editorial.banner.description")}
        </Typography>
      </Box>
    </Box>
  );
};

export default EditorialBanner;
